import { UtilService } from "./utils";
import { Listener } from "./listener";
const tools = {
    /**
     * 判断SolidWorks是否打开
     * @return {true | false}
     */
    checkSWOpen() {
        return window.tools.checkSWOpen();
    },
    //#region 【插件和菜单】
    /**
     * 获取配置
     */
    getConfig() {
        const res = (parent.window || window).tools.getConfig();
        return res == "failed" ? [] : JSON.parse(res);
    },
    /**
     * 保存配置
     */
    saveConfig(contents) {
        return (parent.window || window).tools.saveConfig(JSON.stringify(contents));
    },
    /**
     * 安装SolidWorks插件
     */
    registerSwTool() {
        return (parent.window || window).tools.registerSwTool();
    },
    /**
     * 获取已装插件列表
     * 输出：[{SoftKey,SoftID,FilePath}]
     */
    getInstalledTools() {
        const res = (parent.window || window).tools.getInstalledTools();
        return res == "failed" ? [] : JSON.parse(res);
    },
    /**
     * 安装插件
     * 入参：{Name,FilePath,SoftKey,SoftID,LogoPath}
     */
    install(contents) {
        return (parent.window || window).tools.install(JSON.stringify(contents));
    },
    /**
     * 打开插件
     */
    open(softKey, softFilePath) {
        return (parent.window || window).tools.open(softKey, softFilePath);
    },
    /**
     * 更新
     *入参：{Name,FilePath,SoftKey,SoftID,LogoPath}
     */
    upgrade(contents) {
        return (parent.window || window).tools.upgrade(JSON.stringify(contents));
    },
    /**
     * 卸载插件
     */
    uninstall(softKey, softId) {
        return (parent.window || window).tools.uninstall(softKey, softId);
    },
    //#endregion 【插件和菜单】
    //#region【模型驱动】
    /**
     * 模型下载校验
     * @param fnName
     */
    downModelCheck(fnName) {
        (parent.window || window).tools.downModelCheck(fnName);
    },
    /**
     * 驱动特征模型
     */
    driveModel(modelData, callback) {
        let callbackName = `driveModelCallback${UtilService.Guid()}`;
        Listener.add(callbackName, callback);
        return (window || parent.window).tools.driveModel(JSON.stringify(modelData), callbackName);
    },
    /**
     * 驱动中间模型
     */
    driveStep(modelData) {
        return (window || parent.window).tools.driveStep(JSON.stringify(modelData));
    },
    //#endregion 【模型驱动】
    //#region SW模板相关
    /**
     * 安装焊接轮廓库
     */
    installHJLKLib() {
        return (parent.window || window).tools.installHJLKLib();
    },
    /**
     * 安装迈迪文件模板
     */
    installMdFileTemplate() {
        return (parent.window || window).tools.installMdFileTemplate();
    },
    /**
     * 安装迈迪材质库
     */
    installMdMaterialLib() {
        return (parent.window || window).tools.installMdMaterialLib();
    },
    //#endregion SW模板相关
};
export default tools;
